import useMeasure from "utils/hooks/useMeasure";
import Activity from "features/trades/TradeDrawer/Timeline/Activity";
import NewLookTimeline from "features/trades/TradeDrawer/Timeline/NewLookTimeline.tsx";
import styled, { useTheme } from "styled-components";
import { useContext, useEffect, useRef, useState } from "react";
import { getActivityColor } from "@shared/utils/charts";
import { TradeDetailsContext } from "@shared/features/trades/TradeDetails.context";
import { EXTRA_DETAILS_DRAWER_SCROLL_ID } from "common/constants";

const Timeline = () => {
  const appTheme = useTheme();
  const { pricePrecision, activities, statsData } =
    useContext(TradeDetailsContext)!;
  const [measureRef, { width }] = useMeasure<HTMLDivElement>();
  const [numToRender, setNumToRender] = useState<number>(BATCH_SIZE);
  const numToRenderRef = useRef<number>(undefined);
  numToRenderRef.current = numToRender;
  const numItems = activities?.length ?? 0;

  useEffect(() => {
    const onScroll = (event: any) => {
      const element = event.target;
      const reachedBottom =
        element.scrollHeight - element.scrollTop - element.clientHeight < 100;
      if (reachedBottom && (numToRenderRef.current || 0 < numItems)) {
        setNumToRender((numToRender) => numToRender + BATCH_SIZE);
      }
    };
    const container = document.getElementById(EXTRA_DETAILS_DRAWER_SCROLL_ID);
    container?.addEventListener("scroll", onScroll);
    return () => {
      container?.removeEventListener("scroll", onScroll);
    };
  }, []);

  const getActivities = () => {
    return (
      <>
        {activities?.slice(0, numToRender)?.map((activity, index) => {
          const { color, textColor } = getActivityColor(
            activity.activity_component,
            appTheme
          );
          return (
            <Activity
              key={index}
              activity={activity}
              color={color}
              textColor={textColor}
              priceCoin={statsData?.main_coin}
              pricePrecision={pricePrecision}
            />
          );
        })}
      </>
    );
  };

  return (
    <MeasureWrapper ref={measureRef}>
      <ContentWrapper>
        {appTheme.isNewLook ? <NewLookTimeline /> : getActivities()}
      </ContentWrapper>
    </MeasureWrapper>
  );
};

export default Timeline;

const PADDING_BOTTOM = 50;
const BATCH_SIZE = 15;

const MeasureWrapper = styled.div`
  width: 100%;
  height: 100%;
`;
const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
`;
